import * as React from 'react';
import {ICarouselProps} from './ICarousel';

export const cssTranslate = (position: number, metric: 'px'| '%', axis: 'horizontal'|'vertical'): string =>  {
    const positionPercent = position === 0 ? position : position + metric;
    const positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
    const transitionProp = 'translate3d';

    const translatedPosition = '(' + positionCss.join(',') + ')';

    return transitionProp + translatedPosition;
};

export const defaultStatusFormatter = (current: number, total: number): string => `${current} of ${total}`;

export const isKeyboardEvent = (e?: React.MouseEvent | React.KeyboardEvent): e is React.KeyboardEvent =>{
    return e? Object.prototype.hasOwnProperty.call(e, 'key'): false;
};

export const getPosition = (index: number, props: ICarouselProps): number=> {
    if(props.infiniteLoop) {
        index = index + 2;
    }
    if(index === 0) {
        return 0;
    }
    const childrenLength = React.Children.count(props.children);
    if(props.leftMode) {
        return -index * props.centerSlidePercentage;
    }
    if(props.centerMode && props.axis ==='horizontal' && props.slideToChange === 1) {
        let currentPosition = -index * props.centerSlidePercentage;
        const lastIndex = childrenLength -1;
        if(index && (index !== lastIndex || props.infiniteLoop)) {
            currentPosition += (100 - props.centerSlidePercentage) /2;
        }
        else {
            currentPosition += 100 - props.centerSlidePercentage;
        }

        return currentPosition;
    }

    return -index *100;
};

export const setPosition = (position: number, axis: 'horizontal' | 'vertical'): React.CSSProperties => {
    return { transform: cssTranslate(position, '%', axis) };
};

export const outerWidth = (el: HTMLElement): number =>{
    let width = el.offsetWidth;
    const style = getComputedStyle(el);

    width +=parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
};

export const filterChildren = (children: React.ReactChild[] | null | undefined): React.ReactChild[] | null | undefined =>{
    if(children === null || undefined || children!.length === 0) {
        return children;
    }
    else{
        return children!.filter(child => !!child);
    }

};
